import React, { useState } from "react";

import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

import { createStyles, makeStyles } from "@mui/styles";

import { useSelector } from "react-redux";
import CommonLayout from "../Common/Layout";
import Last20Jobs from "../Dashboard/Last20Jobs";
import JobsFilter from "../Dashboard/JobsFilter";

const CompletedJobs = ({ isSupplierDashboard }) => {
  const { user } = useSelector((state) => state);
  const role = user.currentUser?.Role_id;
  const [filters, setFilters] = useState({ status: 'completed' }); // Default to 'Completed' status

  const useStyles = makeStyles((theme) =>
    createStyles({
      StatusDrp: {
        "& .MuiSelect-select:focus": {
          backgroundColor: "transparent",
        },
      },
    })
  );
  const classes = useStyles();

  const handleFilterChange = (newFilters) => {
    setFilters((prevFilters) => ({ ...prevFilters, ...newFilters, status: 'completed' }));
  };

  const handleReset = () => {
    // Resetting filters but keeping the Completed status
    setFilters({ status: 'completed' });
  };

  const breadcrumbArr = [{ link: "#", displayName: "Completed Jobs", active: true }];

  return (
    <CommonLayout title={isSupplierDashboard ? "Supplier Completed Jobs" : "Completed Jobs"} breadcrumbArr={breadcrumbArr} loading={false} autoScroll={true}>
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4, ml: 0 }} className="main-contant-wrap">
        {/* For Roles other than Supplier (Supplier Role_id - 4) */}
        {role !== 4 && (
          <AppBar
            sx={{
              position: "relative",
              boxShadow: 0,
              backgroundColor: "#e8edf1",
            }}
          >
            <Toolbar
              sx={{
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                justifyContent: "space-between",
              }}
            >
              <JobsFilter
                onFilterChange={handleFilterChange}
                onSearch={handleFilterChange}
                onReset={handleReset}
                classes={classes}
                initialFilters={filters}
                hideStatusFilter={true}
                isSupplierDashboard={isSupplierDashboard}
              />
            </Toolbar>
          </AppBar>
        )}
        {role === 3 && (
          <Typography style={{ fontSize: "22px", fontWeight: "400", marginBottom: 5, marginTop: 30 }}>
            All Jobs
          </Typography>
        )}
        <Last20Jobs user={user.currentUser} isSupplierDashboard={isSupplierDashboard} filters={filters} />
      </Container>
    </CommonLayout>
  );
};

export default CompletedJobs;
